/* eslint-disable @typescript-eslint/no-non-null-assertion */
type Fetcher<T> = () => Promise<T>;

interface CacheEntry<T> {
    value?: T;
    expiresAt?: number;
    inFlight?: Promise<T>;
}

export class DataCache<T> {
    private cache: CacheEntry<T> = {};

    constructor(
        private fetcher: Fetcher<T>,
        private ttlMs = 60000
    ) {}

    async get(forceRefresh = false): Promise<T> {
        const now = Date.now();

        if (!forceRefresh && this.cache.value !== undefined && this.cache.expiresAt! > now) {
            return this.cache.value;
        }

        // Prevent duplicate fetches
        if (this.cache.inFlight) {
            return this.cache.inFlight;
        }

        this.cache.inFlight = this.fetcher()
            .then((data) => {
                this.cache.value = data;
                this.cache.expiresAt = Date.now() + this.ttlMs;
                return data;
            })
            .finally(() => {
                this.cache.inFlight = undefined;
            });

        return this.cache.inFlight;
    }

    invalidate(): void {
        this.cache.expiresAt = 0;
    }

    clear(): void {
        this.cache = {};
    }

    peek(): T | undefined {
        return this.cache.value;
    }
}
